import React, { useMemo } from "react";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import { renderEndDate, renderStartDate } from "../../resume";
import { socialTemplate } from "utils/constant";
import _ from "lodash";
import MilestoneTG from "../../preview/template-three/milestone";
import { QRResume_TEMP_3 } from "../../qr-code/qr-resume";
import Favicon from "components/fav-icon/Favicon";
import { A4_SIZE } from "../../resume";

export default function TemplateThreeFullPageTwo(props) {
  const {
    color = {},
    milestones = {},
    social = {},
    primaryColor,
    tertiaryColor,
    show_image_milestone = true,
    item=[],
    profile,
    page=1,
    totalPage,
    show_qr_milestone,
    show_qr_reels,
    milestone_position=[]
  } = props;

  const activeColor = useMemo(() => {
    if (color.label === "Voilet + Pink") {
      return tertiaryColor;
    }
    return primaryColor;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  // const socMed = useMemo(() => {
  //   let arrays = Object.entries(social);
  //   return arrays.map((obj) => {
  //     let key = obj[0];
  //     let value = obj[1];
  //     return { key, value };
  //   });
  // }, [social]);

  // 1.371

  return (
    <div className="w-full" style={A4_SIZE}>
      <div
        className="w-full bg-resumeTempThreePrimary h-full">
        <div className="w-full h-full">
          <div className="w-full h-full grid relative grid-row-auto">
            <div
              className="w-full h-full px-13.5">
              {/* page number */}
              <div className="w-full relative">
                <div className="w-8 h-8 bg-resumeTempThreeSecondary template-three-page-number">
                  <p className="text-xl text-resumeTempThreeTextSecondary tracking-resumeThree leading-3.2 font-semibold font-template-three">
                    {page<10 && "0"}{page}
                  </p>
                </div>
              </div>
              {/* body */}
              <div className="w-full mt-8.6 grid"> 
                <MilestoneTG
                      items={item}
                      milestones={milestones}
                      primaryColor={primaryColor}
                      show_image_milestone={show_image_milestone}
                      tertiaryColor={tertiaryColor}
                      activeColor={activeColor}
                      profile={profile}
                      fullPreview = {true}
                      milestone_position={milestone_position}

                    />
                {totalPage === page && 
                    <QRResume_TEMP_3 {...{show_qr_milestone,show_qr_reels}} />
                }
              </div>
            </div>
            {/* footer */}
            <div className="w-full flex items-end">
              <div className="w-full h-11.5 bg-resumeTempThreeTextPrimary bg-opacity-20 relative">
                <div className="w-full h-full flex flex-row justify-center items-center space-x-3 text-resumeTempThreeTextPrimary">
                  {Array.isArray(social) && (social || []).map((obj, index) => {
                   
                      return (
                        <div
                          className="flex items-center space-x-1.5"
                          key={index}>
                          <Favicon domain={obj.value} hasFavIconFile={obj.icon} width="w-[15px]"/>
                          {/* <p className="text-4xs leading-4">{obj.value}</p> */}
                        </div>
                      );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
